export const APPOINTMENT_MODES = {
  SCHEDULE: 'schedule',
  RESCHEDULE: 'reschedule',
};
